/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_TitleInputs */

const cs_property_legal_title = /** @type {(inputs: Property_Legal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název dokumentu`)
};

const en_property_legal_title = /** @type {(inputs: Property_Legal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document title`)
};

/**
* | output |
* | --- |
* | "Document title" |
*
* @param {Property_Legal_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_title = /** @type {((inputs?: Property_Legal_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_title(inputs)
	return cs_property_legal_title(inputs)
});